<template src="./StoreComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, watch, reactive} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import ModalProductExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import ModalProductImportComponent from "@/components/modals/modal-product-import/ModalProductImportComponent.vue";
import ModalExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import {useStore} from "@/stores/store.js";

export default {
  name: 'StoreComponent',
  components: {
    ModalExportComponent,
    ModalProductImportComponent,
    LoadingComponent,
    ModalProductExportComponent,
    ModalDeliveryProductListComponent,
    SelectCustom,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const dataHeaderTable =  ref({
      name: {
        label: 'Tên cửa hàng',
        order: 1,
        width: '20%',
      },
      code: {
        label: 'Mã cửa hàng',
        order: 2,
        width: '8%',
      },
      phone: {
        label: 'Số điện thoại',
        order: 3,
        width: '10%',
      },
      address: {
        label: 'Địa chỉ',
        order: 4,
        width: '10%',
      },
    })
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonCreate = ref('Tạo cửa hàng')
    const urlOrigin = ref('/stores/list/')
    const dataSearch = ref({
      store_name: {
        id: 'store_name',
        label: 'Tên cửa hàng',
        placeholder: 'Tên cửa hàng',
        value: '',
        required: false
      },
      store_code: {
        id: 'store_code',
        label: 'Mã cửa hàng',
        placeholder: 'Mã cửa hàng',
        value: '',
        required: false
      },
    })
    const checkAll = ref(false)
    const checkItems = ref({})
    const listItemSelected = ref([])
    const eventClickShowModalExport = ref(false)
    const eventClickShowModalImport = ref(false)
    const listStoresSelected = ref([])
    const isLoading = ref(false)
    const messError = ref('')
    const location = ref('Cửa hàng')
    const table = ref('store')


    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_STORE))
    const selectLimitPage = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PAGE))
    const storeCompStore = useStore()
    const accountStore = useAccountStore()
    const router = useRouter()

    onMounted(() => {
      getListStore(router.currentRoute.value.query.page ?? 1);
    });

    const listStores = computed(() => {
      return storeCompStore.storesLimit;
    });
    const paginate = computed(() => {
      return storeCompStore.paginate;
    });

    function emitPage(page) {
      getListStore(page);
    }
    function redirectToCreate() {
      router.push('/stores/create')
    }

    function getListStore(page, take = 10) {
      const params = {
        id: accountStore.account.company.id,
        name: dataSearch.value.store_name.value,
        code: dataSearch.value.store_code.value,
        page: page,
        take: take,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      storeCompStore.getListStores(url, params);
    }

    watch(() => storeCompStore.storesLimit, (newListStores) => {
      newListStores.forEach((store) => {
        if(checkItems.value[store.id] === undefined) {
          checkItems.value[store.id] = false
        }
      })
    });
    function searchProducts() {
      getListStore(1);
    }

    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        listStores.value.forEach((product) => {
          if(listItemSelected.value.indexOf(product.id) === -1) {
            listItemSelected.value.push(product.id)
          }
        })
      }
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listStores.value.forEach((product) => {
        if(checkItems.value[product.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(product.id) === -1 && parseInt(name) === parseInt(product.id)) {
          listItemSelected.value.push(product.id)
        }else if (!value && listItemSelected.value[product.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(product.id), 1);
        }
      })
      checkAll.value = false
      if(counterChecked === listStores.value.length) {
        checkAll.value = true
      }
    }
    function actionSelect(key) {
      if(listItemSelected.value.length === 0) {
        CommonService.showAlertPopup({
          title: 'Vui lòng chọn dữ liệu để thực hiện!',
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
      }else {
        switch (parseInt(key)) {
          case AppConstant.ACTION_STORE_DELETE:
            deleteStore();
            break;
        }
      }
    }

    async function actionLimitPage(key) {
      switch (parseInt(key)) {
        case AppConstant.LIMIT_PAGE_10:
          await getListStore(1, AppConstant.LIMIT_PAGE_10);
          break;
        case AppConstant.LIMIT_PAGE_20:
          await getListStore(1, AppConstant.LIMIT_PAGE_20);
          break;
        case AppConstant.LIMIT_PAGE_50:
          await getListStore(1, AppConstant.LIMIT_PAGE_50);
          break;
      }
    }

    async function deleteStore() {
      const params = {
        company_id: accountStore.account.company.id,
        store_ids: listItemSelected.value,
      }

      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/delete';
      const product = await storeCompStore.deleteStore(url, params);
      await CommonService.showAlertPopup({
        title: product?.message,
        icon: product?.status,
        showConfirmButton: false,
        timer: 1200,
        width: '800px'
      });
      await getListStore(router.currentRoute.value.query.page ?? 1);
    }

    function showStoreDetail(storeId) {
      router.push('/stores/detail/' + storeId)
    }

    function showErrorMessage(mess) {
      messError.value = mess
    }

    function removeError() {
      messError.value = ''
    }

    return {
      listStores,
      dataHeaderTable,
      labelButtonSearch,
      labelButtonCreate,
      dataSearch,
      paginate,
      urlOrigin,
      checkAll,
      listItemSelected,
      checkItems,
      selectAction,
      selectLimitPage,
      eventClickShowModalExport,
      eventClickShowModalImport,
      listStoresSelected,
      isLoading,
      messError,
      location,
      table,
      onChangeSelectAll,
      onChangeSelectItem,
      emitPage,
      redirectToCreate,
      searchProducts,
      onChange,
      actionSelect,
      actionLimitPage,
      showErrorMessage,
      removeError,
      showStoreDetail,
      CommonText,
      CommonService,
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          td.store-name {
            max-width: 500px;
            p {
              overflow-y: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              margin: 0;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
